import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import {
    CaAnalysisDialogState,
    defaultState,
} from '../ca-analysis-dialog.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<ActionType.COACHING__CA__RESET, Reset>,
): CaAnalysisDialogState {
    return {
        ...state,
        statuses: [],
        transcriptStatus: defaultState().transcriptStatus,
        result: null,
    };
}
